import { render, staticRenderFns } from "./productionSaleModel.vue?vue&type=template&id=3807aa80&scoped=true"
import script from "./productionSaleModel.vue?vue&type=script&lang=js"
export * from "./productionSaleModel.vue?vue&type=script&lang=js"
import style0 from "./productionSaleModel.vue?vue&type=style&index=0&id=3807aa80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3807aa80",
  null
  
)

export default component.exports